import { Component, Ref, Prop } from "@eastsideco/salvo-ts";
import { ThemeComponent } from "@/theme/ThemeComponent";
import { SitePopup } from "../SitePopup/SitePopup";
import { YouTubePlayer } from "youtube-player/dist/types";
import YT from 'youtube-player';
import Player from "@vimeo/player";

export class VideoTrigger extends ThemeComponent {

    @Ref({ required: false }) video!: HTMLVideoElement;
    @Ref({ required: false }) trigger!: HTMLElement;

    @Prop() host!: string;
    @Prop({ default: null }) externalVideoId!: string|null;
    @Prop({ default: 'site-popup__player' }) targetId!: string|null;

    private player:YouTubePlayer|Player|null = null;
    private sitePopup:SitePopup|null = null;
    private popupVideoElement:HTMLDivElement|null = null;

    init() {

        this.$listen(this.trigger, 'click', () => {

            this.sitePopup = document.querySelector('.site-popup') as SitePopup;

            if (!this.sitePopup || !this.targetId) { return; }

            // Create a wrapper element
            // This acts as a target that the player will replace
            const playerTarget = document.createElement('div');
            const sitePopupVideo = document.createElement('div');
            const sitePopupContent = this.sitePopup.querySelector('.site-popup__content');
            playerTarget.id = 'site-popup__player';
            sitePopupVideo.classList.add('site-popup__video');
            sitePopupVideo?.appendChild(playerTarget);
            sitePopupContent?.appendChild(sitePopupVideo);

            this.popupVideoElement = sitePopupVideo;

            // If external Youtube video, create the player
            if (this.host === 'youtube' && this.externalVideoId) {
                this.displayYoutube(this.externalVideoId, this.targetId);
            }

            // If external Youtube video, create the player
            if (this.host === 'vimeo' && this.externalVideoId) {
                this.displayVimeo(this.externalVideoId, this.targetId);
            }

            // If Shopify hosted video, a video element should exist
            // within the component
            if (this.host == 'shopify' && this.video) {
                this.displayHostedVideo(this.video);
            }

        });
    }

    /**
    * Handle Youtube videos.
    * @param targetId - string
    * @param videoId - string
    */
    private displayYoutube(videoId: string, targetId:string) {
        if (!this.sitePopup || !targetId) { return; }

        // Create player
        this.player = YT(targetId, {
            height: '100%',
            videoId: String(videoId),
            width: '100%',
            playerVars: {
                playsinline: 1
            }
        });
        // Open popup
        this.sitePopup.open('video');
        // Play the video
        this.player?.playVideo().then(() => {
        }).catch((error: Error) => {
            this.$log.error(error.message);
        });
    }

    /**
    * Handle Vimeo videos.
    * @param targetId - string
    * @param videoId - string
    */
    private displayVimeo(videoId: string, targetId:string) {
        if (!this.sitePopup || !targetId || !targetId) { return; }

        // Create player
        this.player = new Player(targetId, {
            id: Number(videoId)
        });
        // Open popup
        this.sitePopup.open('video');
        // Play the video
        this.player.play().then(() => {
        }).catch((error: Error) => {
            this.$log.error(error.message);
        });
    }

    /**
    * Handle Shopify hosted videos.
    * @param targetId - string
    * @param videoId - string
    */
    private displayHostedVideo(video: HTMLVideoElement) {
        if (!this.sitePopup || !video || !this.popupVideoElement) { return; }

        // Add video element to popup
        const videoElement = video.outerHTML;
        this.popupVideoElement.innerHTML = videoElement;
        const popupVideo = this.popupVideoElement.querySelector('video');
        // Open popup
        this.sitePopup.open('video');
        // Play the video
        popupVideo?.play();
    }
}
